import { useState } from 'react';
import { BOOK_WAITLIST_URL } from '../../siteData';
import Icon from '../Icon/icon';

// The Theory Book card on the links page, with its waitlist. Sign-ups go to a Brevo
// form (BOOK_WAITLIST_URL), using the field names from Brevo's own embed code. Brevo's
// form endpoint does not allow reading its reply from another site, so the request is
// sent "no-cors" and a request that reaches Brevo counts as success.
const BookWaitlist = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | done | error
  const enabled = Boolean(BOOK_WAITLIST_URL);

  const submit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    const data = new FormData();
    data.append('EMAIL', email.trim());
    data.append('email_address_check', ''); // Brevo's spam trap: must stay empty
    data.append('locale', 'en');
    data.append('html_type', 'simple');
    try {
      await fetch(BOOK_WAITLIST_URL, { method: 'POST', body: data, mode: 'no-cors' });
      setStatus('done');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className={`links-card is-soon${open ? ' is-open' : ''}`}>
      <div className="links-book-row">
        <span className="links-badge"><Icon name="book" /></span>
        <span className="links-body">
          <span className="links-eyebrow">Amazon</span>
          <span className="links-title">The Theory Book</span>
        </span>
        <span className="links-soon">Coming soon</span>
      </div>

      {enabled && !open && (
        <button className="waitlist-open" type="button" onClick={() => setOpen(true)}>
          Join the waitlist
        </button>
      )}

      {enabled && open && status !== 'done' && (
        <form className="waitlist-form" onSubmit={submit}>
          <label className="waitlist-label" htmlFor="waitlist-email">
            Get an email when the book is out.
          </label>
          <div className="waitlist-row">
            <input
              id="waitlist-email"
              className="waitlist-input"
              type="email"
              inputMode="email"
              autoComplete="email"
              placeholder="you@example.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="waitlist-submit" type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending…' : 'Notify me'}
            </button>
          </div>
          {status === 'error' && (
            <p className="waitlist-note is-error">That didn't go through. Please try again.</p>
          )}
        </form>
      )}

      {status === 'done' && (
        <p className="waitlist-done" role="status">
          You're on the list! Check your inbox to confirm.
        </p>
      )}
    </div>
  );
};

export default BookWaitlist;
